// DealStageChip — MD3 Chip с цветом по стадии сделки.
// R41 / U-16: подпись стадии через i18n (formatStage, ключи crm.deals.stage.*),
// а не через hardcoded-константу — ru/en переключение работает.
// U-19 (sled-V9 W5): STAGE_COLORS — единый источник из lib/dealStages.ts (общий с DealStagePath).
import { Chip } from '@mui/material';
import type { DealStage } from '@/api/deals';
import { t } from '@/i18n';
import { formatStage } from '@/lib/format';
import { STAGE_COLORS } from '@/lib/dealStages';

interface DealStageChipProps {
  /** Стадия сделки. */
  stage: DealStage;
  /** Размер чипа. */
  size?: 'small' | 'medium';
}

/** MD3 Chip для отображения стадии сделки. */
export function DealStageChip({ stage, size = 'small' }: DealStageChipProps): JSX.Element {
  return (
    <Chip
      data-testid="deal-stage-chip"
      label={formatStage(stage, t)}
      color={STAGE_COLORS[stage]}
      size={size}
      variant="outlined"
    />
  );
}
